export default __webpack_public_path__ + "static/media/Print.3e23b025.svg";